import { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { api } from '../api.js';
import { useAuth } from '../auth.jsx';
import Alert from '../components/ui/Alert.jsx';
import { EmptyState, Loading, PageHeader, Section } from '../components/ui/index.jsx';
import { fmtDateRange } from '../utils/format.js';
import EventModal from './events/EventModal.jsx';

export const EVENT_STATUS = { draft: { tone: 'warn', label: 'Draft' }, live: { tone: 'good', label: 'Live' }, archived: { tone: 'neutral', label: 'Archived' } };
const EVENT_PLAIN = { draft: ['Not live yet', 'neutral'], live: ['Live', 'good'], archived: ['Archived', 'neutral'] };

export default function Events() {
  const { organisation } = useAuth();
  const navigate = useNavigate();
  const [events, setEvents] = useState(null);
  const [brands, setBrands] = useState([]);
  const [error, setError] = useState('');
  const [creating, setCreating] = useState(false);

  useEffect(() => {
    api('/portal/events').then((d) => setEvents(d.events)).catch((e) => setError(e.message));
    if (organisation) {
      api(`/portal/organisations/${organisation.id}/brands`)
        .then((d) => setBrands(d.brands.filter((b) => b.status === 'active'))).catch(() => {});
    }
  }, [organisation]);

  const newButton = <button type="button" className="btn btn-primary" onClick={() => setCreating(true)}>New event</button>;

  return (
    <div className="page">
      <PageHeader title="Your events"
        subtitle="Each event gets its own check page and forwarding address. It trusts your company’s official channels as well as its own."
        actions={events?.length > 0 && newButton} />

      {error && <Alert tone="danger">{error}</Alert>}
      {events === null && !error && <Loading />}
      {events?.length === 0 && (
        <Section>
          <EmptyState title="No events yet" action={newButton}>
            Your company&rsquo;s channels are already set up. Create an event, add anything specific to it, then put its check page link in your email footers.
          </EmptyState>
        </Section>
      )}
      {events?.length > 0 && (
        <div className="ev-cards">
          {events.map((ev) => {
            const st = EVENT_PLAIN[ev.status] || EVENT_PLAIN.draft;
            return (
              <Link key={ev.id} to={`/events/${ev.id}`} className="ev-card">
                <span className="ev-card-top">
                  <span className={`msg-pill tone-${st[1]}`}>{st[0]}</span>
                  <span className="muted small">{fmtDateRange(ev.starts_on, ev.ends_on)}</span>
                </span>
                <strong className="ev-card-name">{ev.name}</strong>
                {brands.length > 0 && <span className="muted small">{ev.brand?.name || 'Your company'}</span>}
                <span className="mono ev-card-url">{ev.verify_url ? ev.verify_url.replace(/^https?:\/\//, '') : `summitshield.io/validate/${ev.slug}`}</span>
                <span className="muted ev-card-foot">{ev.identifier_count} official channel{Number(ev.identifier_count) === 1 ? '' : 's'} of its own · Open →</span>
              </Link>
            );
          })}
        </div>
      )}

      {creating && (
        <EventModal brands={brands} onClose={() => setCreating(false)} onSaved={(event) => navigate(`/events/${event.id}`)} />
      )}
    </div>
  );
}
